import React, { useState, useEffect } from "react";
import config from "../config";
import { useLanguage } from "../LanguageContext";
import ComponentQuote from "./quote";

const ComponentCaseStudy = ({ uniqueKey, data }) => {
  const {
    caseStudy,
    case_study_categories,
    logos,
    CTA,
    customer,
    tagline,
    image,
    image1,
    image2,
    introduction,
    keyChallenges,
    solution,
    testimonial,
    products,
  } = data.data.attributes;
  const darkMode = window.matchMedia("(prefers-color-scheme: dark)").matches;
  const { currentLocale } = useLanguage();
  const [loading, setLoading] = useState(true);
  const [stringTable, setStringTable] = useState(null);

  const fetchStringTable = async (locale) => {
    try {
      const response = await fetch(
        `${config.apiBaseUrl}/api/string-table?populate=*&locale=${locale}`
      );
      if (!response.ok) {
        throw new Error("Navigation not found");
      }
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error fetching navigation:", error);
      throw error;
    }
  };

  useEffect(() => {
    setLoading(true);
    fetchStringTable(currentLocale)
      .then((data) => {
        const stringArray = data.data.attributes.string;
        // Transform the array into an object without modifying the keys
        const stringObj = stringArray.reduce((acc, cur) => {
          acc[cur.key] = cur.value;
          return acc;
        }, {});
        setStringTable(stringObj);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, [uniqueKey, data, darkMode, currentLocale]);

  return loading ? (
    <div>Loading...</div>
  ) : (
    <>
      <div className="component component-case-study">
        <div className="meta-headline">
          Kunde: {customer} <br />
          Umsetzungszeit: 10.02.2024 - 13.08.2024 <br />
          Anlagegröße: 1500 m²
        </div>
        <h2>{tagline}</h2>
        <p>{introduction}</p>
        {image?.data && (
          <figure className="component-figure">
            <img
              src={`${config.apiBaseUrl}${image.data.attributes.url}`}
              alt={image.data.attributes.alternativeText}
            />
            {image.data.attributes.caption && (
              <figcaption>{image.data.attributes.caption}</figcaption>
            )}
          </figure>
        )}
        {stringTable.casestudy_solution && (
          <h3>{stringTable.casestudy_challenges}</h3>
        )}
        <p>{keyChallenges}</p>
        {image1?.data && (
          <figure className="component-figure">
            <img
              src={`${config.apiBaseUrl}${image1.data.attributes.url}`}
              alt={image1.data.attributes.alternativeText}
            />
            {image1.data.attributes.caption && (
              <figcaption>{image1.data.attributes.caption}</figcaption>
            )}
          </figure>
        )}
        {stringTable.casestudy_solution && (
          <h3>{stringTable.casestudy_solution}</h3>
        )}
        <p>{solution}</p>
        {testimonial && <ComponentQuote data={data.data.attributes} />}
        {stringTable.casestudy_solution && (
          <h3>{stringTable.casestudy_story}</h3>
        )}
        <p>{caseStudy}</p>
        {image2?.data && (
          <figure className="component-figure">
            <img
              src={`${config.apiBaseUrl}${image2.data.attributes.url}`}
              alt={image2.data.attributes.alternativeText}
            />
            {image2.data.attributes.caption && (
              <figcaption>{image2.data.attributes.caption}</figcaption>
            )}
          </figure>
        )}
        <h3>Used Products</h3>
        <p>
          Um APD Schlauchtechnik optimal auszustatten haben wir folgende
          Produkte aus unsere Lösungen eingebaut:
        </p>
        Todo: Teaser Blocks / oder Content 50/50
        {products?.data && (
          <section className="component component-teasers">
            {products.data.map((product, index) => (
              <div
                key={`product_${index}`}
                className="component component-teaser"
                layout="medium"
                style={{
                  "--bg-teaser-start": "green",
                  "--bg-teaser-end": "blue",
                }}
              >
                <h3>{product.attributes.productName}</h3>
                <p>{product.attributes.tagline}</p>
                {product.attributes.productImage?.data && (
                  <img
                    src={`${config.apiBaseUrl}${product.attributes.productImage.data.attributes.url}`}
                    alt={
                      product.attributes.productImage.data.attributes
                        .alternativeText
                    }
                  />
                )}
                <a href={`/${product.attributes.slug}`} className="link--cta">
                  Discover {product.attributes.title}
                </a>
              </div>
            ))}
          </section>
        )}
        {logos?.data && (
          <section className="component component-our-client">
            <h3>Our Client</h3>
            <svg>
              <use xlinkHref="#apd" />
              <defs>
                <symbol
                  dangerouslySetInnerHTML={{
                    __html: logos.data[0].attributes.SVG,
                  }}
                />
              </defs>
            </svg>
            <p>
              Um APD Schlauchtechnik optimal auszustatten haben wir folgende
              Produkte aus unsere Lösungen eingebaut.
            </p>
            <a href={`/${logos.data[0].attributes.url}`} className="link--cta">
              Discover APD
            </a>
          </section>
        )}
      </div>

      {/* <section className="component component-teasers">
        <div
          className="component component-teaser"
          layout="large"
          style="--bg-teaser-start: blue; --bg-teaser-end: yellow"
        >
          <h3>L230 | L235</h3>
          <p>
            L 230 | 235 Pallet Dimensioner, our hanging solution is offering you
            another way to use our system.
          </p>
          <img
            src="images/l-series-2.png"
            alt="describing what's happening in the image"
          />
          <a href="#" className="link--cta">
            Discover the L-Series
          </a>
        </div>

        <div
          className="component component-teaser"
          layout="large"
          style="--bg-teaser-start: blue; --bg-teaser-end: yellow"
        >
          <h3>S140</h3>
          <p>
            S140 Pallet Dimensioner, our hanging solution is offering you
            another way to use our system.
          </p>
          <img
            src="images/teaser.png"
            alt="describing what's happening in the image"
          />
          <a href="#" className="link--cta">
            Discover the S-Series
          </a>
        </div>
      </section> */}

      <div className="sticky-sidebar">
        <h3>Want us to help you?</h3>
        <p>Fill out the form, and we get back in no time!</p>
        <a
          href={`/${CTA[0].page.data.attributes.slug}?case=${data.data.attributes.slug}`}
          className="link--cta"
        >
          {CTA[0].label}
        </a>
      </div>
    </>
  );
};

export default ComponentCaseStudy;
